import { useStaticQuery, graphql } from "gatsby"

export const useWhyChooseQuery = () => {
    const { wpPage } = useStaticQuery(
        graphql`
        query WhyChooseQuery {
            wpPage(title: {eq: "Home"}) {
              whyChoose {
                whyChooseBackgroundImageMobile {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
                whyChooseBackgroundImageDesktop {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
                whyChooseBackgroundImageAltText
                whyChooseHeading
                whyChooseSubheading
                whyChooseSmallText
                whyChooseImageMobile {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                whyChooseImageDesktop {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                whyChooseImageAltText
                whyChooseReasons {
                  whyChooseIcon {
                    localFile {
                      childSvg {
                        content {
                          data
                        }
                      }
                    }
                  }
                  whyChooseText
                }
              }
            }
          }
        `)
return wpPage.whyChoose
}